























































import { Component, Vue } from "vue-property-decorator";
import CButton from "@/basics/buttons/CButton.vue";
import DeleteModal from "@/components/modal/DeleteModal.vue";
import ResetModal from "@/components/modal/ResetModal.vue";
import SimpleTable from "@/basics/table/SimpleTable.vue";
import {
  USER_ONE_DATA,
  UserData,
  UserOneVariables
} from "@/graphql/query/user/one";
import { USER_ME, UserData as Me } from "@/graphql/query/user/me";
import { deleteUser } from "@/graphql/mutation/deleteUser";
import { resetUser } from "@/graphql/mutation/resetUser";
import { updateUser } from "@/graphql/mutation/updateUser";
import { toString } from "@/lib/scope";
import { downloadAsFile } from "@/lib/download";

@Component({
  components: {
    CButton,
    DeleteModal,
    ResetModal,
    SimpleTable
  },
  apollo: {
    user: {
      query: USER_ONE_DATA,
      variables(): UserOneVariables {
        return {
          userId: this.$apollo.vm.$route.params.userId
        };
      }
    },
    me: USER_ME
  }
})
export default class UserDetails extends Vue {
  user: UserData | null = null;
  me: Me | null = null;
  reset: boolean = false;
  deleted: boolean = false;
  resetModal: boolean = false;
  deleteModal: boolean = false;

  get role(): string {
    return toString(this.user!.scopes, this.user!.group.id);
  }

  get thisIsMe(): boolean {
    return this.user!.id === this.me!.id;
  }

  async resetPassword() {
    this.reset = true;
    const { data } = await resetUser(this.$apollo, this.user!.id);

    const user = this.user!;
    const email = typeof user.email === "string" ? user.email : "";

    if(!data) throw new Error("データが取得できませんでした")      

    const csv = `ユーザー名,権限,メールアドレス,ログインID,パスワード
${user.name},${this.role},${email},${user.loginId},${data.resetUser}
`;
    downloadAsFile(`${user.name}.csv`, "text/csv", csv);
    this.resetModal = false;
  }

  async deleteUser() {
    try {
      await deleteUser(this.$apollo, this.user!.id);
      this.$router.push({ name: "group-users" });
    } catch {
      alert("削除に失敗しました");
      this.deleteModal = false;
    }
  }
}
